export default __webpack_public_path__ + "static/media/waterfowl@3x.d9670325.jpg";